export function articleAnchorList() {
    $(".single-article-title .anchors-block").on("click", ".button-close", function (e) {
        $(this).parents(".anchors-block").toggleClass("hide-list").find(".list").slideToggle(300);
        e.preventDefault();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/articleAnchorList.js